module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_02_6NX26_1SF_GSK.c7b8f63b.png";